// extracted by mini-css-extract-plugin
export var statusConfirmButtonWrap = "_5b00226259197253501407abb9af7c39-css";